import React from "react";
import { FaUserGroup, FaDisplay, FaUsers, FaGlobe } from "react-icons/fa6";
import { Container, H1_SIZE } from "../home/ui";

// Hero artwork (three teammates around a laptop). File: public/img/about-hero.jpg (cropped from the design mockup;
// swap in a high-res export when available).
const heroImg = "/img/about-hero1.jpg";

// NOTE: keep these numbers accurate for DataMetricks. Years / projects / clients match the other pages;
// "10+ Countries Served" comes from the design mockup, confirm it.
const stats = [
  { icon: FaUserGroup, value: "5+", label: "Years of Experience", tone: "bg-[#E3EDFF] text-[#2563EB]" },
  { icon: FaDisplay, value: "100+", label: "Projects Delivered", tone: "bg-[#DFF7EC] text-[#10B981]" },
  { icon: FaUsers, value: "50+", label: "Happy Clients", tone: "bg-[#EEE6FF] text-[#7C3AED]" },
  { icon: FaGlobe, value: "10+", label: "Countries Served", tone: "bg-[#FFEDD5] text-[#F97316]" },
];

const fadeX = "linear-gradient(to right, transparent 0%, #000 10%, #000 94%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, transparent 0%, #000 6%, #000 94%, transparent 100%)";
const edgeFade = {
  WebkitMaskImage: `${fadeX}, ${fadeY}`,
  WebkitMaskComposite: "source-in",
  maskImage: `${fadeX}, ${fadeY}`,
  maskComposite: "intersect",
};

const AboutHero = () => (
  <section className="relative overflow-hidden bg-gradient-to-r from-[#FBFCFE] via-[#F7F9FF] to-[#EEF3FE] pb-[48px] pt-[110px] lg:pb-[64px] xl:pt-[calc(clamp(76px,5.83vw,112px)+32px)]">
    <Container className="relative max-w-[1320px]">
      <div className="grid items-center gap-[24px] lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)]">
        <div className="m-hero">
          <span className="inline-flex items-center rounded-full bg-[#E3EDFF] px-[16px] py-[6px] text-[13px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
            About Us
          </span>

          <h1 className={`mt-[18px] font-extrabold tracking-tight text-[#0B1A4A] ${H1_SIZE}`}>
            We Build Digital
            {" "}<br />
            Solutions for a
            {" "}<br />
            <span className="text-[#1E6BFF]">Better Tomorrow</span>
          </h1>

          <p className="mt-[18px] max-w-[540px] text-[16px] leading-[1.6] text-slate-600 sm:text-[17px] xl:text-[clamp(15px,1.05vw,19px)]">
            We are a passionate team of developers, designers and problem solvers, helping businesses grow with modern web and
            mobile solutions.
          </p>
        </div>

        <div className="flex justify-center lg:justify-end">
          <img
            src={heroImg}
            alt="DataMetricks team working together on a laptop"
            className="h-auto w-full max-w-[620px] select-none object-contain"
            style={edgeFade}
          />
        </div>
      </div>

      <div className="mt-[28px] grid grid-cols-2 gap-y-[24px] rounded-[20px] bg-white px-[12px] py-[24px] shadow-[0_18px_50px_-24px_rgba(40,60,140,0.3)] sm:py-[28px] lg:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.label}
            className={`flex flex-col items-center text-center ${i > 0 ? "lg:border-0 lg:border-l lg:border-solid lg:border-[#E8EDF6]" : ""}`}
          >
            <span className={`inline-flex h-[56px] w-[56px] items-center justify-center rounded-full text-[22px] ${s.tone}`}>
              <s.icon />
            </span>
            <p className="mt-[12px] text-[28px] font-extrabold leading-none text-[#0B1A4A] xl:text-[clamp(26px,2vw,36px)]">{s.value}</p>
            <p className="mt-[8px] text-[14px] text-slate-600">{s.label}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default AboutHero;
